/**
 * Sets up the routing for all admin views relating to the User resource.
 */

const simUrl = window.simUrl;

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import user agenda views
import CompletedTraining from '../user/views/CompletedTraining.js.jsx';
import ExpiredAgenda from './views/ExpiredAgenda.js.jsx';
import ExpiringSoonAgenda from './views/ExpiringSoonAgenda.js.jsx';
import MyAgenda from './views/MyAgenda.js.jsx';
import PendingAgenda from './views/PendingAgenda.js.jsx';
import ProgramAgenda from './views/ProgramAgenda.js.jsx';
import ProgramResources from './views/ProgramResources.js.jsx';
import SponsorAgenda from './views/SponsorAgenda.js.jsx';

// import evaluation views
import EvaluationIntro from '../evaluation/views/EvaluationIntro.js.jsx';
import EvaluationQuestion from '../evaluation/views/EvaluationQuestion.js.jsx';
import PostEvaluation from '../evaluation/views/PostEvaluation.js.jsx';

// import contentModule admin views
import ContentModuleConclusion from '../contentModule/views/ContentModuleConclusion.js.jsx';
import ContentModuleNodeRedirect from '../contentModule/views/ContentModuleNodeRedirect.js.jsx';
import ContentModuleOverviewRedirect from '../contentModule/views/ContentModuleOverviewRedirect.js.jsx';

class MyAgendaRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let moduleOverviewPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/node/'), 0);
    let programAgendaPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/resources'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display: 'My agenda', path: null}]}
          component={MyAgenda}
          exact
          login={true}
          path="/my-agenda"
        />
        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Program', path: null }
          ]}
          component={SponsorAgenda}
          exact
          login={true}
          path="/my-agenda/sponsor/:sponsorId"
        />
        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Program', path: null }
          ]}
          component={ProgramAgenda}
          exact
          login={true}
          path="/my-agenda/program/:studySlug"
        />
        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Program', path: programAgendaPath }
            , {display: 'Resources', path: null }
          ]}
          component={ProgramResources}
          exact
          login={true}
          path="/my-agenda/program/:studySlug/resources"
        />
        <YTRoute
          breadcrumbs={[{display: 'Expiring Training', path: null}]}
          component={ExpiringSoonAgenda}
          exact
          login={true}
          path="/my-agenda/expiring-soon"
        />
        <YTRoute
          breadcrumbs={[{display: 'Expiring Training', path: null}]}
          component={ExpiredAgenda}
          exact
          login={true}
          path="/my-agenda/expired"
        />
        <YTRoute
          breadcrumbs={[{display: 'Expiring Training', path: null}]}
          component={CompletedTraining}
          exact
          login={true}
          path="/my-agenda/completed"
        />
        <YTRoute
          breadcrumbs={[{display: 'Pending Training', path: null}]}
          component={PendingAgenda}
          exact
          login={true}
          path="/my-agenda/pending"
        />

        {/* REDIRECT LEGACY URLS, relevant for the secure landing page redirects */}
        <Redirect exact from='/my-agenda/tms/:contentModuleSlug' to='/my-agenda/cms/:contentModuleSlug' />
        {/* we will redirect the legacy routes from the following two components, since they use different params */}
        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Module overview', path: null }
          ]}
          component={ContentModuleOverviewRedirect}
          exact
          login={true}
          path="/my-agenda/cms/:contentModuleSlug" // legacy route
        />
        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Module overview', path: moduleOverviewPath}
            , {display: 'Scene', path: null }
          ]}
          component={ContentModuleNodeRedirect}
          exact
          login={true}
          path="/my-agenda/cms/:contentModuleSlug/node/:nodeId" // legacy route
        />

        <YTRoute
          breadcrumbs={[
            {display: 'My agenda', path: '/my-agenda'}
            , {display: 'Module conclusion', path: null }
          ]}
          component={ContentModuleConclusion}
          exact
          login={true}
          path="/my-agenda/cms/:contentModuleSlug/conclusion"
        />
        <YTRoute login={true} exact path="/my-agenda/cms/:contentModuleSlug/evaluations/:evaluationId" component={EvaluationIntro} />
        <YTRoute login={true} exact path="/my-agenda/cms/:contentModuleSlug/evaluations/:evaluationId/q/:questionId" component={EvaluationQuestion} />
        <YTRoute login={true} exact path="/my-agenda/cms/:contentModuleSlug/evaluations/:evaluationId/post-evaluation" component={PostEvaluation} />
      </Switch>
    )
  }
}

export default withRouter(MyAgendaRouter);



// WEBPACK FOOTER //
// modules/agenda/MyAgendaRouter.js.jsx